export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_08.7b7e4634.jpg";